module.exports = __webpack_public_path__ + "JAC-logo.png";